import * as React from 'react';
import { errorHandler } from '../../../error/handler';
import { getDisponibilita, getDisponibilitaList } from '../../../fetch/dettaglio/attributes/disponibilita';
import { IDisponibilita } from '../../../interfaces/dettaglio/attributes/models';
import { normalizer } from '../../../lib/normalizer';
import { emptyAction, getAction, listAction } from '../../../store/dettaglio/attributes/disponibilita/actions';
import { IDisponibilitaState } from '../../../store/dettaglio/attributes/disponibilita/types';
import { useAppDispatch } from '../../../store/hooks';
import { endActionToDoAction, startActionToDoAction } from '../../../store/ui/actions';

export const useDisponibilitaGet = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-disponibilita';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const disponibilita = await getDisponibilita(id);
				dispatch(getAction(disponibilita));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useDisponibilitaList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-disponibilita';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getDisponibilitaList();
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IDisponibilita>(_items, "id");
				const actionPayload: IDisponibilitaState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}
